import { createPaginatedInfiniteQuery, type QueryApi } from "../../api/query";

export function createUseProductSearch($api: QueryApi) {
  const usePaginatedInfiniteQuery = createPaginatedInfiniteQuery($api);

  return function useProductSearch(params: { q: string; size?: number }) {
    return usePaginatedInfiniteQuery(
      "/products/search",
      { q: params.q, size: params.size ?? 20 },
      { enabled: params.q.length >= 3, staleTime: 30_000 },
    );
  };
}
